//cart-drawer check validation
$("#CartDrawer-Form").on("submit",function()
{
  /*  
  if(!$("#conform_check_2").prop("checked"))
    {
        $(".input_error").removeClass('hidden');        
    }
    else
    {
        $(".input_error").addClass('hidden');
        return true;
    }    
     return false;
  */
  return true;
})


$(document).on('click',".Click-here.popup_polices_click", function() {
  var atr_name = $(this).attr('popup_tab');
  console.log(atr_name)
  $('.pop-up-content-wrap .popup_main[popup_tab]').addClass('hidden');
  $('.pop-up-content-wrap .popup_main[popup_tab='+ atr_name +']').removeClass('hidden');
  $(".custom-model-main").addClass('model-open');
});
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
  $('.pop-up-content-wrap [popup_tab]').addClass('hidden');
});

function addClasslogin() {
  setTimeout(function(){ window.location.hash.includes('#recover') ? document.body.classList.add('forgot_password_page') : document.body.classList.remove('forgot_password_page') },100) 
}

$(document).ready(function() {
  $('input.selected_var').trigger('click');
  addClasslogin();
});

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });
}
  function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
    tabs_content_toggel.forEach(b => {
      if(b.getAttribute('data-hendles') == tabs_data){
           b.classList.add("active");
          document.querySelector(b.getAttribute('data-hendles')).classList.remove("hidden");
      }else{
         b.classList.remove("active");
        if (document.querySelector(b.getAttribute('data-hendles'))) {
           document.querySelector(b.getAttribute('data-hendles')).classList.add("hidden");
        }
      }
    });
  }
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
    function image_hide(imag){
       let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
        images_val.forEach(b => {
          if(b.alt == imag){
            b.classList.remove("hidden");
          }else{
            b.classList.add("hidden");
          }
        });
      }
    let main_images = document.querySelector(".header__inline-menu");
    if(main_images){
      let images = main_images.querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);
    }



// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro && content){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
faq_taggol();
// accordions js end

function shothing_click() {
  $(".cstm-sorting").click(function(){
    $(this).toggleClass("active");
    $(this).parents(".custom-sort").find("ul").toggleClass("active");
  });
}

$('.custom_change').on('change', function () {
  $(".form-show .pxFormGenerator").addClass('hidden');
  var $select_val = $(this).val();
  console.log($select_val)
  $('.pxFormGenerator[id="'+ $select_val +'"]').removeClass('hidden');
});

$(document).ready(function(){

// var swiperContainer = document.querySelector('.tab_with_image.swiper');
// if(swiperContainer){
//   swiperContainer.addEventListener('mouseenter', function() {
//     swiper.autoplay.stop();
//   });
  
//   swiperContainer.addEventListener('mouseleave', function() {
//     swiper.autoplay.start();
//   });
// }
shothing_click();

if ($('.pdp_detail').length < 1) {
  $('.upseller_tag_line').hide();
}

// page redirect to checkout and apply coupon
if (document.getElementById('add-to-cart-button')) {
  document.getElementById('add-to-cart-button').addEventListener('click', function(event) {
    event.preventDefault();
    var form = document.getElementById('add-to-cart-form_custom');
    var formData = new FormData(form);
    fetch(form.action, {
      method: form.method,
      body: formData,
    }).then(function(response) {
      if (response.ok) {
        var discount_ctext = document.querySelector("[coupon_code]");
        var discount_code = discount_ctext.getAttribute("coupon_code");
        var theUrl = '/checkout?discount='+discount_code;
        window.location.href = theUrl;
      } else {
        console.error('Failed to add to cart:', response.statusText);
      }
    }).catch(function(error) {
      console.error('Error:', error);
    });
  });
}

  // artical slider
  var swiper = new Swiper(".artical__blog_swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: true,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 20
        }
      }
    });
  var swiper = new Swiper(".article_image_slider_wrp", {
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: true,
      loop:true,
      navigation: {
        nextEl: ".image_swiper-button-next",
        prevEl: ".image_swiper-button-prev",
      },
    });

  if (document.body.clientWidth < 768) {
    $(".article-template__hero-container").insertBefore(".article_left_side_content.article_item");
    $(".article_collapsible.article_collapsible-green_color").insertAfter(".article-template__hero-container");
  }


  
 var swiper = new Swiper('.swiper_tab_image', {
    slidesPerView: 7,
    spaceBetween: 0,
    loop:false,
     navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
   breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 10
      },
     480: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      800:{
        slidesPerView: 3,
        spaceBetween: 10
      },
      1000:{
        slidesPerView: 4,
        spaceBetween: 10
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      1450:{
        slidesPerView: 6,
        spaceBetween: 10
      }
      
    }
  });
  
 var swiper = new Swiper('.custom_blog_list', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
    989: {
        slidesPerView: 3,
        spaceBetween: 20
      }
      
    }
  });

  var swiper = new Swiper(".center_img_swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    loop:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });  

  if($(window).innerWidth() <= 768) {

   var swiper = new Swiper(".tab_slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop:false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
  }
  
});


 $(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.js-acc-single-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  $(".accordion-single-item:first-of-type").addClass("open");  

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
    };
  } 

  var accordion = new Accordion($('#pdp_accordion'), false);
});  


// put this js in end  // scroll
 let mouseDown = false;
    let startX, scrollLeft;
    const slider = document.querySelector('.main-blog .articles-tags');
    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }
    const stopDragging = (e) => {
      mouseDown = false;
    }
    const move = (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    }
    // Add the event listeners
      if(slider){
          slider.addEventListener('mousemove', move, false);
          slider.addEventListener('mousedown', startDragging, false);
          slider.addEventListener('mouseup', stopDragging, false);
          slider.addEventListener('mouseleave', stopDragging, false);  
      }

$(function () {
    "use strict";
    
    $(".popup img").click(function () {
        var $src = $(this).attr("src");
        $(".show").fadeIn();
        $(".img-show img").attr("src", $src);
    });
    
    $("span, .overlay").click(function () {
        $(".show").fadeOut();
    });

// if(!document.body.classList.contains('template--product')){
//     $(".swiper").hover(function() {
//       (this).swiper.autoplay.stop();
//     }, function() {
//         (this).swiper.autoplay.start();
//     });
// }
  
});

$('.tab-btn .btn').click(function(){
  $('.tab-btn .btn').removeClass('active');
  $(this).addClass('active');
});

$("[data-popup-open-click]").click(function () {
   $('[data-popup-content]').hide();
   $($(this).attr('data-popup-id')).show();
   window.scrollTo(0, 0);
  $('body').addClass("open_popup");
}); 

$('[data-close-popup]').click(function () {
  $('[data-popup-content]').hide();
  $('body').removeClass("open_popup");
});

// product tab section
$('.tabs_header .main_tab_trigger').click(function() {
  var handle = $(this).attr('data_handle');
  $('.tab_trigger button').removeClass('active');
  $(this).find('button').addClass('active');
  
  $('.tab_mai_mappert').addClass('hidden').removeClass('active_tab');
  $('.tab_mai_mappert[data_handle="' + handle + '"]').removeClass('hidden').addClass('active_tab');
  $('.toggal_all_tabs_content[tab_number="' + handle + '"]').removeClass('hidden');
  var handle1 = $(this).closest('.tabs_cover').find('.image-with-text').attr('tab_number');
  var handle2 = $(this).closest('.tabs_cover').find('.tab_information').attr('tab_number');
  $('.image-with-text[tab_number="' + handle1 + '"],.tab_information[tab_number="' + handle2 + '"]').removeClass('hidden');
  if ($('.custom_futterungsempfehlung_length').length == 1 ) {
    $('.futterungsempfehlung_inner').addClass('center_align_tab');
  }else{
  }
  if ($('.custom_zutaten_length').length == 1) {
    $('.zutaten_inner').addClass('center_align_tab');
  }else{
    console.log("22")
  }
});


//old accordion tab functionality, don't remove!

// $('.inner_tabs_sec .sub_tab').click(function() {
//   var handle = $(this).attr('tab-sub-handle');
//   $('.tab_trigger .sub_tab_toggle').removeClass('active');
//   $(this).find('.sub_tab_toggle').addClass('active');
//   console.log(handle)
//   $('.image-with-text,.tab_information').addClass('hidden');
//   $('.image-with-text[tab-sub-handle="' + handle + '"],.tab_information[tab-sub-handle="' + handle + '"]').removeClass('hidden');
// });


$('.inner_tabs_sec .sub_tab').click(function() {
  var block_handle_div = $(this).closest('.accordion-pannel')
  var handle_name = block_handle_div.attr('block_handle')
  var handle = $(this).attr('tab-sub-handle');
  if(block_handle_div && handle_name){
    $('[block_handle="' + handle_name + '"] .tab_trigger .sub_tab_toggle').removeClass('active');
    $(this).find('.sub_tab_toggle').addClass('active');
    $('[block_handle="' + handle_name + '"] .image-with-text, [block_handle="' + handle_name + '"] .tab_information').addClass('hidden');
    $('[block_handle="' + handle_name + '"] .image-with-text[tab-sub-handle="' + handle + '"],[block_handle="' + handle_name + '"] .tab_information[tab-sub-handle="' + handle + '"]').removeClass('hidden');
  }else{
    $('.tab_trigger .sub_tab_toggle').removeClass('active');
    $(this).find('.sub_tab_toggle').addClass('active');
    console.log(handle)
    $('.image-with-text,.tab_information').addClass('hidden');
    $('.image-with-text[tab-sub-handle="' + handle + '"],.tab_information[tab-sub-handle="' + handle + '"]').removeClass('hidden');
  }
  
});



// multiplae tab js

const tabs = document.querySelectorAll(".tab");

function tabify(tab) {
  const tabList = tab.querySelector(".tab__list");

  if (tabList) {
    const tabItems = [...tabList.children];
    const tabContent = tab.querySelector(".tab__content");
    const tabContentItems = [...tabContent.children];
    let tabIndex = 0;

    // tabIndex = tabItems.findIndex((item, index) => {
    //   return [...item.classList].indexOf("is--active") > -1;
    // });

    // tabIndex > -1 ? (tabIndex = tabIndex) : (tabIndex = 0);

    function setTab(index) {
      tabItems.forEach((x, index) => x.classList.remove("is--active"));
      tabContentItems.forEach((x, index) => x.classList.remove("is--active"));

      tabItems[index].classList.add("is--active");
      if(tabContentItems[index]){
       tabContentItems[index].classList.add("is--active"); 
      }      
    }

    tabItems.forEach((x, index) =>
      x.addEventListener("click", () => setTab(index))
    );
    setTab(tabIndex);
    tab.querySelectorAll(".tab").forEach((tabContent) => tabify(tabContent));
  }
}

tabs.forEach(tabify);

// When any accordion title is clicked...
$(".accordion__title").click(function() {
  tabs.forEach(tabify);
  const $accordion_wrapper = $(this).parent();
  const $accordion_content = $(this).parent().find(".accordion__content").first();
  const $accordion_open = "accordion--open";

  // If this accordion is already open
  if ($accordion_wrapper.hasClass($accordion_open)) {
    $accordion_wrapper.removeClass($accordion_open);  // Remove the accordionm--open class.
    $accordion_content.slideUp();                     // Close the content.
  }
  // If this accordion is not already open
  else {
    $accordion_wrapper.addClass($accordion_open);   // Add the accordion--open class.
    $accordion_content.slideDown();
  }
});



//sub tab 

$(function () {
  
  $(".accordion-content:not(:first-of-type)").css("display", "none");
  
  $(".js-accordion-title:first-of-type").addClass("open");
 
  $(".js-accordion-title").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});


setTimeout(function(){
var lastShownTime = localStorage.getItem('popupLastShownTime');
var currentTime = new Date().getTime();
var oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

// Check if 24 hours have passed since the last shown time
if (!lastShownTime || (currentTime - lastShownTime) > oneDay) {
  // Show the popup
  $('#newsletter-popup').fadeIn();
  
  // Update the last shown time in localStorage
  localStorage.setItem('popupLastShownTime', currentTime);
}

// Close the popup when the close button is clicked
$('.close-popup').click(function() {
  $('#newsletter-popup').fadeOut();
});

// Close the popup when clicking outside of the popup content
$(window).click(function(event) {
  if ($(event.target).is('#newsletter-popup')) {
    $('#newsletter-popup').fadeOut();
  }
});
},10000);

$('.read_more_btn').click(function() {
    $(this).closest('.pro_short_description').hide();
    $(this).closest('.pro_short_description').next('.pro_full_description').show();
  });
  
  $('.read_less_btn').click(function() {
    $(this).closest('.pro_full_description').hide();
    $(this).closest('.pro_full_description').prev('.pro_short_description').show();
  });


$('.gift_text').click(function (params) {
  $('.upsale_cover_main').toggle();
  $('.gift_text').toggleClass('arrow_slide');
});

// blog sorting

$("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
    });

function sortBlogPosts(option) {
  var postsContainer = $(".blog-articles");
  var posts = postsContainer.children(".cust_sort_blog");

  switch (option) {
    case "title-ascending":
      posts.sort(function(a, b) {
        return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
      });
      break;
    case "title-descending":
      posts.sort(function(a, b) {
        return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
      });
      break;
    case "created-ascending":
      posts.sort(function(a, b) {
        var dateA = new Date($(a).find(".blog-post-date").text());
        var dateB = new Date($(b).find(".blog-post-date").text());
        return dateA - dateB;
      });
      break;
    case "created-descending":
      posts.sort(function(a, b) {
        var dateA = new Date($(a).find(".blog-post-date").text());
        var dateB = new Date($(b).find(".blog-post-date").text());
        return dateB - dateA;
      });
      break;
    default:
      // No sorting, maintain original order
      break;
  }

  postsContainer.empty().append(posts);
}


// blog search js

$('.blog-search').on('input', function(){
    var get_input = $(this).val().toLowerCase(); 
    $('.blog-articles__article').each(function(){
        var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
        }
        else{
            $(this).hide();
        }
    });
});

$('.filter-search').on('input', function(){
    var get_input = $(this).val().toLowerCase();
    $('.custom_filter').each(function(){
        var articleHeading = $(this).find('.facet-checkbox__text-label').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
        }
        else{
            $(this).hide();
        }
    });
});


$(document).on('click', '.facets__summary', function(){
  $(this).toggleClass('cust_slide');
});

// video section
$(".box-video").click(function(){
  $('iframe',this)[0].src += "&amp;autoplay=1";
  $(this).addClass('open');
});


//  wissen tab section
$('.bottom-btn [button_tab]').click(function () {
  var button_tab = $(this).attr('button_tab');
  console.log('button_tab',button_tab)
  var tab_data = $('.multilevel-tabs .main-acc[tab_data = '+ button_tab +']').attr('tab_data');
  console.log("tab_data",tab_data)
  $('.multilevel-tabs .main-acc[tab_data] .accordion__content ').css('disaply','none')
  $('.multilevel-tabs .main-acc[tab_data = '+ button_tab +'] .accordion__title').trigger('click');
  smoothScroll($('.multilevel-tabs .main-acc[tab_data = '+ button_tab +'] .accordion__title'));
});

$('.ingredient_text_ p').click(function () {
  var main_tab = $(this).attr('main_tab');
  // console.log("main_tab",main_tab);
  $('.ingredient_text_ p').removeClass('active');
  $('.ingredient_text_ p[main_tab='+main_tab+']').addClass('active');
  $('.data_json').addClass('hidden');
  var data_1= $('.data_json[tab_data='+main_tab+']');
  $(data_1).removeClass('hidden');
  // console.log("fata",data_1)
});
// =============collection sorting 

//Blog tag 
  var selectedTab = localStorage.getItem('selectedMainTab');
  if (selectedTab) {
    $('.main_tab_blog[main_tab=' + selectedTab + ']').addClass('active');
    $('.sub_cate .swiper-slide_1[tab_data=' + selectedTab + ']').removeClass('hidden');
  }

  $('.main_tab_blog').click(function (e) {
    e.preventDefault();
    var main_tab = $(this).attr('main_tab');
    localStorage.setItem('selectedMainTab', main_tab);
    $('.main_tab_blog').removeClass('active');
    $(this).addClass('active');
    $('.sub_cate .swiper-slide_1').addClass('hidden');
    $('.sub_cate .swiper-slide_1[tab_data=' + main_tab + ']').removeClass('hidden');
  });
//end blog tab

$('.custom_sel_all_bt').click(function () {
   $('ul.custom_swatch_filter label.swatch-input__label').click();
});



(function() {
  const login_re = document.querySelector('.login_dsc_cls a') || null;
    const login_re_click = document.querySelector('a.psw-txt') || null;
  if(login_re && login_re_click){
            login_re.addEventListener("click", (e) => {
            e.preventDefault();
                 login_re_click.click();
            });
  }
    })();

$(document).on("click", ".header__menu-item[redirect_url]", function(){
  document.querySelector('summary.header__menu-item').querySelector('a').click();
});


var navigation = $("[data-faq__categories-list-item-link-cust] a");
navigation.on("click", "a", function (event) {
  event.preventDefault();
  console.log(event)
  console.log($(this.hash))
  smoothScroll($(this.hash));
});

// var page_clcik = $("[click_btn_scroll]");
// page_clcik.on("click", "a.handler-finden", function (event) {
//   event.preventDefault(); //prevents previous event
//   smoothScroll($(this.hash));
// });
  
function smoothScroll(target) {
  var header_hight = (document.querySelector('sticky-header').offsetHeight + 10) || 150;
    $("body,html").animate(
        {
            scrollTop: target.offset().top - header_hight
        },
        300
    );
}



  document.addEventListener('rk_cart_event', function (e) {
    var cart = e.detail.cart;
    console.log(cart);
    const this_cartDrawer = document.querySelector('cart-drawer');
    this_cartDrawer.refresh(true);
    // Shopify.afterCartUpdate(cart);
  }, false);

// Zoom product Image


// !function e(t,n,i){function s(l,a){if(!n[l]){if(!t[l]){var r="function"==typeof require&&require;if(!a&&r)return r(l,!0);if(o)return o(l,!0);var h=new Error("Cannot find module '"+l+"'");throw h.code="MODULE_NOT_FOUND",h}var u=n[l]={exports:{}};t[l][0].call(u.exports,function(e){var n=t[l][1][e];return s(n?n:e)},u,u.exports,e,t,n,i)}return n[l].exports}for(var o="function"==typeof require&&require,l=0;l<i.length;l++)s(i[l]);return s}({1:[function(e,t,n){(function(t){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function s(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}();Object.defineProperty(n,"__esModule",{value:!0}),n.VERSION=void 0;var l=e("./util/dom"),a=e("./injectBaseStylesheet"),r=i(a),h=e("./Trigger"),u=i(h),d=e("./ZoomPane"),c=i(d),f=(n.VERSION="0.1.1",function(){function e(t){var n=this,i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];if(s(this,e),this.destroy=function(){n._unbindEvents()},this.triggerEl=t,!(0,l.isDOMElement)(this.triggerEl))throw new TypeError("`new Drift` requires a DOM element as its first argument.");var o=i.namespace,a=void 0===o?null:o,h=i.showWhitespaceAtEdges,u=void 0===h?!1:h,d=i.containInline,c=void 0===d?!1:d,f=i.inlineOffsetX,m=void 0===f?0:f,g=i.inlineOffsetY,v=void 0===g?0:g,p=i.sourceAttribute,y=void 0===p?"data-zoom":p,w=i.zoomFactor,_=void 0===w?3:w,E=i.paneContainer,C=void 0===E?document.body:E,b=i.inlinePane,z=void 0===b?375:b,O=i.handleTouch,S=void 0===O?!0:O,L=i.onShow,P=void 0===L?null:L,M=i.onHide,k=void 0===M?null:M,I=i.injectBaseStyles,T=void 0===I?!0:I;if(z!==!0&&!(0,l.isDOMElement)(C))throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");this.settings={namespace:a,showWhitespaceAtEdges:u,containInline:c,inlineOffsetX:m,inlineOffsetY:v,sourceAttribute:y,zoomFactor:_,paneContainer:C,inlinePane:z,handleTouch:S,onShow:P,onHide:k,injectBaseStyles:T},this.settings.injectBaseStyles&&(0,r["default"])(),this._buildZoomPane(),this._buildTrigger()}return o(e,[{key:"_buildZoomPane",value:function(){this.zoomPane=new c["default"]({container:this.settings.paneContainer,zoomFactor:this.settings.zoomFactor,showWhitespaceAtEdges:this.settings.showWhitespaceAtEdges,containInline:this.settings.containInline,inline:this.settings.inlinePane,namespace:this.settings.namespace,inlineOffsetX:this.settings.inlineOffsetX,inlineOffsetY:this.settings.inlineOffsetY})}},{key:"_buildTrigger",value:function(){this.trigger=new u["default"]({el:this.triggerEl,zoomPane:this.zoomPane,handleTouch:this.settings.handleTouch,onShow:this.settings.onShow,onHide:this.settings.onHide,sourceAttribute:this.settings.sourceAttribute})}},{key:"isShowing",get:function(){return this.zoomPane.isShowing}},{key:"zoomFactor",get:function(){return this.settings.zoomFactor},set:function(e){this.settings.zoomFactor=e,this.zoomPane.settings.zoomFactor=e}}]),e}());n["default"]=f,t.Drift=f}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./Trigger":2,"./ZoomPane":3,"./injectBaseStylesheet":4,"./util/dom":5}],2:[function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function s(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}();Object.defineProperty(n,"__esModule",{value:!0});var l=e("./util/throwIfMissing"),a=i(l),r=function(){function e(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];s(this,e),h.call(this);var n=t.el,i=void 0===n?(0,a["default"])():n,o=t.zoomPane,l=void 0===o?(0,a["default"])():o,r=t.sourceAttribute,u=void 0===r?(0,a["default"])():r,d=t.handleTouch,c=void 0===d?(0,a["default"])():d,f=t.onShow,m=void 0===f?null:f,g=t.onHide,v=void 0===g?null:g;this.settings={el:i,zoomPane:l,sourceAttribute:u,handleTouch:c,onShow:m,onHide:v},this._bindEvents()}return o(e,[{key:"_bindEvents",value:function(){this.settings.el.addEventListener("mouseenter",this._show,!1),this.settings.el.addEventListener("mouseleave",this._hide,!1),this.settings.el.addEventListener("mousemove",this._handleMovement,!1),this.settings.handleTouch&&(this.settings.el.addEventListener("touchstart",this._show,!1),this.settings.el.addEventListener("touchend",this._hide,!1),this.settings.el.addEventListener("touchmove",this._handleMovement,!1))}},{key:"_unbindEvents",value:function(){this.settings.el.removeEventListener("mouseenter",this._show,!1),this.settings.el.removeEventListener("mouseleave",this._hide,!1),this.settings.el.removeEventListener("mousemove",this._handleMovement,!1),this.settings.handleTouch&&(this.settings.el.removeEventListener("touchstart",this._show,!1),this.settings.el.removeEventListener("touchend",this._hide,!1),this.settings.el.removeEventListener("touchmove",this._handleMovement,!1))}},{key:"isShowing",get:function(){return this.settings.zoomPane.isShowing}}]),e}(),h=function(){var e=this;this._show=function(t){t.preventDefault();var n=e.settings.onShow;n&&"function"==typeof n&&n(),e.settings.zoomPane.show(e.settings.el.getAttribute(e.settings.sourceAttribute),e.settings.el.clientWidth),e._handleMovement(t)},this._hide=function(t){t.preventDefault();var n=e.settings.onHide;n&&"function"==typeof n&&n(),e.settings.zoomPane.hide()},this._handleMovement=function(t){if(t.preventDefault(),e.isShowing){var n=void 0,i=void 0;if(t.touches){var s=t.touches[0];n=s.clientX,i=s.clientY}else n=t.clientX,i=t.clientY;var o=e.settings.el,l=o.getBoundingClientRect(),a=n-l.left,r=i-l.top,h=a/e.settings.el.clientWidth,u=r/e.settings.el.clientHeight;e.settings.zoomPane.setPosition(h,u,l)}}};n["default"]=r},{"./util/throwIfMissing":6}],3:[function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function s(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}();Object.defineProperty(n,"__esModule",{value:!0});var l=e("./util/throwIfMissing"),a=i(l),r=e("./util/dom"),h="animation"in document.body.style,u=function(){function e(){var t=this,n=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];s(this,e),this._completeShow=function(){t.el.removeEventListener("animationend",t._completeShow,!1),(0,r.removeClasses)(t.el,t.openingClasses)},this._completeHide=function(){t.el.removeEventListener("animationend",t._completeHide,!1),(0,r.removeClasses)(t.el,t.openClasses),(0,r.removeClasses)(t.el,t.closingClasses),(0,r.removeClasses)(t.el,t.inlineClasses),t.el.setAttribute("style",""),t.el.parentElement===t.settings.container?t.settings.container.removeChild(t.el):t.el.parentElement===t.settings.inlineContainer&&t.settings.inlineContainer.removeChild(t.el)},this.isShowing=!1;var i=n.container,o=void 0===i?null:i,l=n.zoomFactor,h=void 0===l?(0,a["default"])():l,u=n.inline,d=void 0===u?(0,a["default"])():u,c=n.namespace,f=void 0===c?null:c,m=n.showWhitespaceAtEdges,g=void 0===m?(0,a["default"])():m,v=n.containInline,p=void 0===v?(0,a["default"])():v,y=n.inlineOffsetX,w=void 0===y?0:y,_=n.inlineOffsetY,E=void 0===_?0:_;this.settings={container:o,zoomFactor:h,inline:d,namespace:f,showWhitespaceAtEdges:g,containInline:p,inlineOffsetX:w,inlineOffsetY:E},this.settings.inlineContainer=document.body,this.openClasses=this._buildClasses("open"),this.openingClasses=this._buildClasses("opening"),this.closingClasses=this._buildClasses("closing"),this.inlineClasses=this._buildClasses("inline"),this._buildElement()}return o(e,[{key:"_buildClasses",value:function(e){var t=["drift-"+e],n=this.settings.namespace;return n&&t.push(n+"-"+e),t}},{key:"_buildElement",value:function(){this.el=document.createElement("div"),(0,r.addClasses)(this.el,this._buildClasses("zoom-pane"));var e=document.createElement("div");(0,r.addClasses)(e,this._buildClasses("zoom-pane-loader")),this.el.appendChild(e),this.imgEl=document.createElement("img"),this.el.appendChild(this.imgEl)}},{key:"_setImageURL",value:function(e){this.imgEl.setAttribute("src",e)}},{key:"_setImageSize",value:function(e){this.imgEl.style.width=e*this.settings.zoomFactor+"px"}},{key:"setPosition",value:function(e,t,n){var i=-(this.imgEl.clientWidth*e-this.el.clientWidth/2),s=-(this.imgEl.clientHeight*t-this.el.clientHeight/2),o=-(this.imgEl.clientWidth-this.el.clientWidth),l=-(this.imgEl.clientHeight-this.el.clientHeight);if(this.el.parentElement===this.settings.inlineContainer){var a=window.scrollX,r=window.scrollY,h=n.left+e*n.width-this.el.clientWidth/2+this.settings.inlineOffsetX+a,u=n.top+t*n.height-this.el.clientHeight/2+this.settings.inlineOffsetY+r;if(this.settings.containInline){this.el.getBoundingClientRect();h<n.left+a?h=n.left+a:h+this.el.clientWidth>n.left+n.width+a&&(h=n.left+n.width-this.el.clientWidth+a),u<n.top+r?u=n.top+r:u+this.el.clientHeight>n.top+n.height+r&&(u=n.top+n.height-this.el.clientHeight+r)}this.el.style.left=h+"px",this.el.style.top=u+"px"}this.settings.showWhitespaceAtEdges||(i>0?i=0:o>i&&(i=o),s>0?s=0:l>s&&(s=l)),this.imgEl.style.transform="translate("+i+"px, "+s+"px)"}},{key:"_removeListenersAndResetClasses",value:function(){this.el.removeEventListener("animationend",this._completeShow,!1),this.el.removeEventListener("animationend",this._completeHide,!1),(0,r.removeClasses)(this.el,this.openClasses),(0,r.removeClasses)(this.el,this.closingClasses)}},{key:"show",value:function(e,t){this._removeListenersAndResetClasses(),this.isShowing=!0,(0,r.addClasses)(this.el,this.openClasses),this._setImageURL(e),this._setImageSize(t),this._isInline?this._showInline():this._showInContainer(),h&&(this.el.addEventListener("animationend",this._completeShow,!1),(0,r.addClasses)(this.el,this.openingClasses))}},{key:"_showInline",value:function(){this.settings.inlineContainer.appendChild(this.el),(0,r.addClasses)(this.el,this.inlineClasses)}},{key:"_showInContainer",value:function(){this.settings.container.appendChild(this.el)}},{key:"hide",value:function(){this._removeListenersAndResetClasses(),this.isShowing=!1,h?(this.el.addEventListener("animationend",this._completeHide,!1),(0,r.addClasses)(this.el,this.closingClasses)):((0,r.removeClasses)(this.el,this.openClasses),(0,r.removeClasses)(this.el,this.inlineClasses))}},{key:"_isInline",get:function(){var e=this.settings.inline;return e===!0||"number"==typeof e&&window.innerWidth<=e}}]),e}();n["default"]=u},{"./util/dom":5,"./util/throwIfMissing":6}],4:[function(e,t,n){"use strict";function i(){if(!document.querySelector(".drift-base-styles")){var e=document.createElement("style");e.type="text/css",e.classList.add("drift-base-styles"),e.appendChild(document.createTextNode(s));var t=document.head;t.insertBefore(e,t.firstChild)}}Object.defineProperty(n,"__esModule",{value:!0}),n["default"]=i;var s="\n@keyframes noop {  }\n\n.drift-zoom-pane.drift-open {\n  display: block;\n}\n\n.drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {\n  animation: noop;\n}\n\n.drift-zoom-pane {\n  position: absolute;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  pointer-events: none;\n}\n\n.drift-zoom-pane-loader {\n  display: none;\n}\n\n.drift-zoom-pane img {\n  position: absolute;\n  display: block;\n}\n"},{}],5:[function(e,t,n){"use strict";function i(e){return e&&"undefined"!=typeof Symbol&&e.constructor===Symbol?"symbol":typeof e}function s(e){return a?e instanceof HTMLElement:e&&"object"===("undefined"==typeof e?"undefined":i(e))&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName}function o(e,t){t.forEach(function(t){e.classList.add(t)})}function l(e,t){t.forEach(function(t){e.classList.remove(t)})}Object.defineProperty(n,"__esModule",{value:!0}),n.isDOMElement=s,n.addClasses=o,n.removeClasses=l;var a="object"===("undefined"==typeof HTMLElement?"undefined":i(HTMLElement))},{}],6:[function(e,t,n){"use strict";function i(){throw new Error("Missing parameter")}Object.defineProperty(n,"__esModule",{value:!0}),n["default"]=i},{}]},{},[1]);

// (function() {
//       const paneContainer = document.querySelector('.product__info-container.product__column-sticky') || null;
//       const product_images_main = document.querySelectorAll('[data-swiper-pdp-slide]') || null;
//         if(paneContainer && product_images_main){
//             product_images_main.forEach(image_main => {
//               const image = image_main.querySelector('img') || null;
//                if(image){
//                      new Drift(image, {
//                       paneContainer: paneContainer,
//                       inlinePane: false,
//                     });
//                  }
//             });
//           }

// })();